import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { bidByIdSelector } from 'state/bid/bid.selectors';

import Page from 'components/page/page.component';

import BidForm from 'components/bid-form/bid-form.component';

const Bid = () => {
    const { id } = useParams();
    const bid = useSelector(bidByIdSelector(id));
    console.log('bid', bid);

    if (!bid) return <Redirect to="/admin/bids" />;

    return (
        <Page
            heroTitle="Bidding Made Simple"
            heroText="Use the form below to submit a bid for the property you are interested in."
            heroSize="small"
        >
            <BidForm readOnly bid={bid} />
        </Page>
    );
};

export default Bid;
